import { FeedbackFormData } from '@sentry/core';
import { uploadDao } from 'shared/dao/uploadDao';
import { objectToFormData } from '../storage/formData';
import { deleteAllFormData, getLatestFormData } from '../storage/indexedDB';
import { updateSentryFeedbackFormInputs } from '../utils/formUtils';

import { removeAttachedImage } from './imageHandlers';
const { uploadMedia } = uploadDao();

// Debounce flag to prevent multiple submissions
let isSubmitting = false;

/**
 * Handler for successful form submission
 * @param data The form data submitted
 */
export const onSubmitSuccess = (data: FeedbackFormData): void => {
  const run = async (): Promise<void> => {
    if (isSubmitting) return;
    isSubmitting = true;

    const { message } = data;
    const name = data.name ? data.name : JSON.parse(localStorage.user).attributes.full_name;
    const email = data.email ? data.email : JSON.parse(localStorage.user).attributes.email;

    // Retrieve the latest FormData from IndexedDB
    try {
      let uploadImage = null;
      const storedFormData = await getLatestFormData();
      if (storedFormData) {
        const response = await uploadMedia(objectToFormData(storedFormData));
        uploadImage = response.data.attributes.attachment_url;
      }
      // Create ticket with uploaded image
      try {
        const description = uploadImage
          ? `
                Message:<br>${message}<br><br>
                Image Upload:<br>
                <img src="${uploadImage}" />
              `
          : `
                Message: ${message}
              `;
        const ticketResponse = await fetch(`${process.env.REACT_APP_MFE_API}/api/freshdesk`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            description: description,
            subject: `[Sentry][${process.env.REACT_APP_ENV.toUpperCase()}][Talent Web]: ${name}`,
            email: email,
            priority: 2,
            status: 2,
          }),
        });

        // Parse response
        await ticketResponse.json();

        const user = JSON.parse(localStorage.getItem('user') as string);
        updateSentryFeedbackFormInputs(user.attributes.email, user.attributes.first_name, user.attributes.last_name);

        // Clean up after successful submission
        await deleteAllFormData();

        removeAttachedImage();
      } catch (error) {
        // Handle fetch error silently to prevent app crashes
      }
    } catch (error) {
      // Handle error silently to prevent app crashes
    } finally {
      // Reset the submission flag after a delay and re-enable the upload button
      setTimeout(() => {
        isSubmitting = false;
      }, 1000);
    }
  };

  run();
};
